import React from 'react';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';
import '../styles/ErrorBoundary.css';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ovde možeš logovati grešku na server (Sentry, LogRocket itd.)
    console.error('Error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <FiAlertTriangle className="error-icon" />
          <h1>Došlo je do greške</h1>
          <p>Nešto je pošlo naopako. Molimo osvežite stranicu.</p>
          <button 
  className="btn-gold"
  onClick={() => window.location.href = '/'}
>
            <FiRefreshCw /> Idi na početnu stranicu
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;